import { useCallback } from 'react';
import { Text } from 'foundations-components/components/Text';
import { NavMarker } from 'react-rhumb';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingButton } from 'foundations-components/transitional/components/LoadingButton';
import { Flex } from 'foundations-components/components/Flex';
import useDebounce from '../../hooks/useDebounce';
import { useOneTimePassword } from './useOneTimePassword';
import { useQueryData } from '../../hooks/useQueryData';
import OneTimePasswordError from './OneTimePasswordError';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const OneTimePasswordComponent = props => {
  const {
    history
  } = props;
  const {
    allQueryParams
  } = useQueryData();
  const {
    otp,
    otpId,
    userId,
    next,
    template
  } = allQueryParams;
  const {
    isLoading,
    responseLanguageKey,
    onLoad,
    resendHandler,
    showActionButton,
    isError,
    templateLanguageKey,
    isLoginLoading,
    setIsLoginLoading
  } = useOneTimePassword({
    otp,
    otpId,
    next,
    template,
    userId
  });
  const debouncedOnLoad = useDebounce(onLoad, 1000);
  const handleClick = useCallback(() => {
    setIsLoginLoading(true);
    debouncedOnLoad();
  }, [debouncedOnLoad, setIsLoginLoading]);
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    justifyContent: "center",
    blockSize: "90vh",
    children: [/*#__PURE__*/_jsx(NavMarker, {
      name: "OTP_PAGE_LOAD"
    }), isLoading ? /*#__PURE__*/_jsxs(Flex, {
      alignItems: "center",
      flexDirection: "column",
      children: [/*#__PURE__*/_jsx(Text, {
        as: "h1",
        marginBlockEnd: "600",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.otp.header"
        })
      }), /*#__PURE__*/_jsx(Text, {
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.otp.description"
        })
      }), /*#__PURE__*/_jsx(LoadingButton, {
        onClick: handleClick,
        use: "primary",
        loading: isLoginLoading,
        disabled: isLoginLoading,
        marginBlockStart: "1000",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "login.otp.button"
        })
      })]
    }) : /*#__PURE__*/_jsx(OneTimePasswordError, {
      isError: isError,
      responseLanguageKey: responseLanguageKey,
      templateLanguageKey: templateLanguageKey,
      showActionButton: showActionButton,
      template: template,
      resendHandler: resendHandler,
      history: history
    })]
  });
};
export default OneTimePasswordComponent;